import React from 'react';

import { useTranslations } from 'components/utilities';
import { Feature } from 'components/elements';
import useCar from '../../../../../../context/useCar';
import DriverIcon from './components/DriverIcon';

const DriverFeature = () => {
	const { t } = useTranslations();

	const {
		carDetails: {
			car: {
				office: { driver_price }
			}
		},
		carDriver,
		handleChangeCarDriver
	} = useCar();

	return (
		<Feature
			icon={DriverIcon}
			name={t('common.driver')}
			price={driver_price}
			selected={carDriver}
			onChange={handleChangeCarDriver}
		/>
	);
};

export default DriverFeature;
